import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1a9af76a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-row" }
const _hoisted_2 = {
  style: {"display":"flex"},
  class: "cm-ui-mr10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _component_GroupPolicyDrawer = _resolveComponent("GroupPolicyDrawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ContentAdaptLayout, { class: "group-policy-wrap important el-card" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _ctx.addPolicy
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('safeProtectionModule.newPolicy')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_container, { style: {"height":"100%"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              "row-key": "group_id",
              "default-expand-all": "",
              width: "100%",
              height: "100%",
              data: _ctx.tableData,
              "empty-text": _ctx.$t('common.noData')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: _ctx.$t('safeProtectionModule.terminalGroup')
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  prop: "total",
                  label: _ctx.$t('safeProtectionModule.terminalCount')
                }, null, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  width: 280,
                  prop: "terminal_count",
                  label: _ctx.$t('safeProtectionModule.deployPolicy')
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_select, {
                      style: {"width":"200px"},
                      size: "small",
                      "model-value": scope.row.strategy_id,
                      onChange: ($event: any) => (_ctx.changePolicy($event, scope.row))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.strategyList, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: index,
                            value: item.id,
                            label: item.name
                          }, null, 8, ["value", "label"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["model-value", "onChange"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["data", "empty-text"])
          ]),
          _: 1
        })), [
          [_directive_loading, _ctx.isLoading]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_GroupPolicyDrawer, {
      modelValue: _ctx.groupPolicyDrawerVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.groupPolicyDrawerVisible) = $event)),
      "operate-type": "add",
      onChange: _ctx.updateStrategyList
    }, null, 8, ["modelValue", "onChange"])
  ], 64))
}